<template>
  <div class="subject_list">
    <span class="title">科目：</span>
    <el-select
      v-model="subjectIdNew"
      placeholder="请选择所属专业科目"
      :disabled="disabled"
      @change="subjectChange"
      size="mini"
      style="width: 156px"
    >
      <el-option
        v-for="item in subjectList"
        :key="item.id"
        :label="item.name"
        :title="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import * as api from "@/api/questionApi";
export default {
  name: "subject-list",
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String],
      default: ''
    },
    all: { // 是否显示全部
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      professionId: sessionStorage.getItem("professional") || "",
      subjectIdNew: "",
      subjectList: [],
    };
  },
  watch: {
    value(val) {
      this.subjectIdNew = val;
    },
  },
  created() {
    this.subjectIdNew = this.value;
    this.getSubjects();
  },
  mounted() {},

  methods: {
    // 获取科目
    getSubjects() {
      api
        .getSubjectData()
        .then((rs) => {
          if (rs.code == 0) {
            this.subjectList = [];
            let obj = {};
            rs.data.forEach((item, i) => {
              if (item.professionId == this.professionId) {
                obj = {
                  id: item.id,
                  name: item.name,
                };
                this.subjectList.push(obj);
              }
            });
            if (this.all) {
              this.subjectList.unshift({
                id: '',
                name: '全部',
              })
            }
            if (this.subjectList.length && !this.subjectIdNew) {
              this.subjectIdNew = this.subjectList[0]["id"]; // 默认第一个
              this.subjectChange();
            }
            sessionStorage.setItem('subjectListForCourse', JSON.stringify(this.subjectList))
            sessionStorage.setItem('defaultSubjectIdForCourse', this.subjectIdNew)
          } else {
            this.$messageError(rs.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    subjectChange() {
      this.$emit('input', this.subjectIdNew)
      this.$emit('subjectChange', this.subjectIdNew);
    },
  },
};
</script>

<style scoped lang="scss">
.subject_list {
  display: flex;
  align-items: center;

  .title {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subject_select.vue